import React, { useState } from "react";
import { Button, Modal } from "antd"; // Ensure this import is correct
import { ExclamationCircleFilled } from "@ant-design/icons";

type ConfirmModalProps = {
  setIsModalOpen: CallableFunction;
  isModalOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  handleSubmitReferral?: CallableFunction;
  isReferralLoading: boolean;
  uhidNo: any;
  schemeSelected: any;
  patientDocType?: any;
};
const ConfirmModalUploadDoc: React.FC<ConfirmModalProps> = (props) => {
  const isReferralPresent = props?.patientDocType?.some((item: any) =>
    item.includes("referral")
  );
  
  return (
    <>
      <Modal
        title={
          <>
            <ExclamationCircleFilled
              style={{ marginRight: 8, color: "#faad14" }}
            />
            CONFIRM
          </>
        }
        open={props?.isModalOpen}
        onOk={props?.handleOk}
        onCancel={props?.handleCancel}
        confirmLoading={props.isReferralLoading}
        okText="YES"
        cancelText="NO"
      >
        <p style={{ fontSize: "16px" }}>
          NO PATIENT FOUND WITH THE PRN{" "}
          <span style={{ fontWeight: "500" }}> {props?.uhidNo}.</span>
          <br />
          <span style={{ fontWeight: "500" }}>
            ANY{" "}
            {isReferralPresent &&
            // parseInt((props?.schemeSelected ?? "").split("-")[0]) !== 3 &&
            //   parseInt((props?.schemeSelected ?? "").split("-")[0]) !== 4 &&
              "REFERRAL LETTER OR "}
            CARD TO UPLOAD ?
          </span>
        </p>
      </Modal>
    </>
  );
};

export default ConfirmModalUploadDoc;
